const languageConfig = Object.freeze({ main: 'english' });
const siteConfig = Object.freeze({
  footerText: '8888ACC ©2016 Created by Cull A., Inc',
  siteName: '8888ACC',
});
export {
  languageConfig,
  siteConfig,
};
